import BasicRoute from "components/routes/BasicRoute";
import PublicInscricaoForm from "../../../entity/Inscricao/components/InscricaoPublic";
import PainelDoInscrito from "entity/Inscricao/components/PainelDoInscrito";
import InscricaoSimplificada from "entity/Inscricao/components/InscricaoSimplificada";

export default function RoutesMenusPublicInscricao() {
    return <>
        <BasicRoute
            uid='publicInscricao'
            route="public-inscricao"
            // menuProps={{
            //     text: "Inscrição Publica",
            //     sequence: "000009",
            //     iconName: "Public",
            // }}
            element={<PublicInscricaoForm />}
        />
        <BasicRoute
            uid='PainelDoInscrito'
            route="painel-inscrito"
            // menuProps={{
            //     text: "Inscrição Publica",
            //     sequence: "000009",
            //     iconName: "Public",
            // }}
            element={<PainelDoInscrito />}
        />
        <BasicRoute
            uid='inscrever-se'
            route="inscrever-se"          
            element={<InscricaoSimplificada />}
        />
    </>;
}